import { YearVehicleDTO } from '@app/src/views/StepOne/form/dtos';
import { YearVehicleModel } from '@app/src/views/StepOne/form/models/yearVehicle';

export const hydrateData = (data: YearVehicleDTO) => ({
  yearIni: data.year_ini,
  yearEnd: data.year_end
}) as YearVehicleModel;
